import React from 'react';

const BoxCard = ({ box, onViewDetails }) => {
  const getLowestPrice = () => {
    if (box.tiers && box.tiers.length > 0) {
      return box.tiers[0].price;
    }
    return 'Contact for pricing';
  };

  const getCategoryLabel = () => {
    const categoryLabels = {
      'baby-shower': 'Baby Shower',
      'birthday': 'Birthday',
      'bachelorette': 'Bachelorette',
      'brunch': 'Brunch',
      'dinner-party': 'Dinner Party',
      'themed': 'Themed'
    };
    return categoryLabels[box.category] || box.category;
  };

  return (
    <div className="box-card">
      <div className="box-card-image">
        <img src={box.image} alt={box.name} loading="lazy" />
        <span className="box-card-badge">{getCategoryLabel()}</span>
      </div>
      <div className="box-card-content">
        <h3>{box.name}</h3>
        <p className="box-vibe">{box.vibe}</p>
        <p className="box-price">Starting at {getLowestPrice()}</p>
        <div className="box-card-actions">
          <button 
            className="btn btn-primary btn-sm"
            onClick={() => onViewDetails(box)}
          >
            View Details
          </button>
          <button 
            className="btn btn-outline-gold btn-sm"
            onClick={() => onViewDetails(box)}
          >
            Order Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default BoxCard;
